enum Storage {
  LANGUAGE = 'language',
  LINKEDIN_STATE = 'linkedin-state',
  INVITATION_TOKEN = 'invitation-token',
  REDIRECT = 'redirect',
}

export default Storage;
